import { useEffect } from 'react';
import { applyTheme, resolveTheme, useThemeStore } from '@/lib/theme-store';

/**
 * Inicializa el tema en el <html> y escucha cambios del system preference
 * cuando el usuario eligio 'system'. Montar una sola vez en App.
 */
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const preference = useThemeStore((s) => s.preference);
  const setResolved = (r: 'light' | 'dark') =>
    useThemeStore.setState({ resolved: r });

  // Aplicar tema al montar y cuando cambia preference.
  useEffect(() => {
    const resolved = resolveTheme(preference);
    setResolved(resolved);
    applyTheme(resolved);
  }, [preference]);

  // Si preference === 'system', escuchar cambios del SO.
  useEffect(() => {
    if (preference !== 'system' || typeof window === 'undefined') return;
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    const onChange = () => {
      const resolved = detectSystemTheme();
      setResolved(resolved);
      applyTheme(resolved);
    };
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [preference]);

  return <>{children}</>;
}

function detectSystemTheme(): 'light' | 'dark' {
  if (typeof window === 'undefined') return 'light';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}